import { GENDER_ENUM } from "@webkit/enums/gender.enum";

export class PersonDto {

    constructor(
        public identificationCode?: string,
        public name?: string,
        public surname?: string,
        public email?: string,
        public mobileNumber?: string,
        public bio?: string,
        public locale?: string,
        public fullAddress?: string,
        public birthDate?: string,
        public gender?: GENDER_ENUM.MALE | GENDER_ENUM.FEMALE | GENDER_ENUM.OTHER,
    
    ) {}
}